import type { ApiGetWorkflowResponseWithUsages } from '@atlassian/jira-project-configuration-commons/src/services/get-workflow/types.tsx';
import {
	type ResourceStoreContext,
	type RouterDataContext,
	createResource,
	useResource,
} from '@atlassian/react-resource-router';
import { fetchWorkflowDocument } from './services/index.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_DOCUMENT';

export const workflowDocumentResource = createResource<ApiGetWorkflowResponseWithUsages>({
	type: RESOURCE_TYPE_KEY,
	getKey: (matchedRoute) => {
		const { workflowId } = matchedRoute.match.params;
		return `${RESOURCE_TYPE_KEY}_${workflowId}`;
	},
	getData: async (routerContext: RouterDataContext, customContext: ResourceStoreContext) =>
		fetchWorkflowDocument(routerContext, customContext, false),
	maxAge: 1000,
	isBrowserOnly: true,
});

export const useWorkflowDocument = () =>
	useResource<ApiGetWorkflowResponseWithUsages>(workflowDocumentResource);
